// extracted by mini-css-extract-plugin
module.exports = {"uiElementCommon":"PowerItemsShopBtn_uiElementCommon__33-tX","button":"PowerItemsShopBtn_button__3DlCK","window":"PowerItemsShopBtn_window__g0M4C"};